import React, { useRef, useState } from 'react';
import { FileUp } from 'lucide-react';
import { replaceModelFile } from '../lib/api';
import { ActionBtn } from '../components/ReorderControls';

export default function ReplaceFileBtn({ it, onSaved, onStatus }) {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const pick = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = '';
    if (!file) return;
    setBusy(true); onStatus(null);
    try {
      await replaceModelFile(it.id, file);
      onStatus({ ok: true, text: `FILE REPLACED WITH ${file.name.toUpperCase()} · TITLE, EXPRESSIONS, LOOKS, STYLE AND TEXTURES KEPT` });
      onSaved();
    } catch (x) {
      onStatus({ ok: false, text: x?.response?.data?.detail || 'Replace failed' });
    }
    setBusy(false);
  };
  return (
    <>
      <input ref={ref} type="file" accept=".glb,.gltf" hidden onChange={pick} data-testid={`admin-replace-input-${it.id}`} />
      <ActionBtn onClick={() => ref.current?.click()} disabled={busy} testId={`admin-replace-${it.id}`} label={`Replace file for ${it.title}`}>
        <FileUp className="w-4 h-4" /><span className="hidden sm:inline">{busy ? 'UPLOADING…' : 'REPLACE FILE'}</span>
      </ActionBtn>
    </>
  );
}
